import React from "react";
import { useLeadDialog } from "@/components/sections/LeadDialog";

export default function WhatsAppFloat() {
  const { open } = useLeadDialog();
  return (
    <button
      type="button"
      onClick={() => open("whatsapp-float")}
      aria-label="Solicitar evaluación por WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white shadow-lg shadow-green-500/30 pl-3 pr-4 py-3 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="h-6 w-6 fill-white"
        aria-hidden="true"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.41 1.963.992 2.75l.43.502 1.203 1.503.645.645c1.403 1.204 3.107 2.293 4.726 2.693.143.043.286.072.43.086h.215c.49 0 1.262-.073 1.663-.358.315-.215.545-.645.545-1.017 0-.287-.073-.587-.26-.802-.287-.286-1.376-.773-1.762-.844zM16.077 8.19c-4.29 0-7.784 3.49-7.784 7.78 0 2.004.77 3.85 2.03 5.21l-.62 1.85 1.92-.61c1.306 1.025 2.947 1.64 4.736 1.64 4.29 0 7.785-3.49 7.785-7.78s-3.495-7.78-7.785-7.78 0 0 0 0zm0 14.24c-1.533 0-2.965-.46-4.16-1.243l-2.906.932.946-2.81c-.885-1.215-1.41-2.717-1.41-4.34 0-4.037 3.288-7.32 7.325-7.32 4.036 0 7.324 3.283 7.324 7.32 0 4.038-3.288 7.32-7.324 7.32v.14z" />
      </svg>
      <span className="text-sm font-semibold hidden sm:inline">
        Solicitar por WhatsApp
      </span>
    </button>
  );
}
